



















import { Component, Vue } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import Transaction from '../models/transaction';
import TransactionList from '../components/TransactionList.vue';

@Component({
  components: {
    TransactionList,
  },
})
export default class Home extends Vue {}
